import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import Button from "@ui-kit/form/Button/Button.web";
import Icon from "@ui-kit/icons/Icon.web";
import Box from "@ui-kit/layout/Box/Box.web";
import { useTranslation } from "@shared/utils/internationalization";
import { MoreInfoButtonProps } from "./MoreInfoButton.props";

/**
 * Displays a More Info button that opens an information modal from the seating banner.
 * Also shows a mobile-only button for recurring events that opens a timeslot selection modal.
 */
const MoreInfoButton = ({
  seatingObject,
  onOpenTimeslotModal,
  onOpenInfoModal,
}: MoreInfoButtonProps) => {
  const { t } = useTranslation("seating");

  return (
    <Flex
      alignItems="center"
      w="fit-content"
      h="100%"
      justifyContent="flex-end"
    >
      <Box minW="element.lg" />
      <Box
        display={{ base: "flex", md: "none" }}
        h={{ base: "80%", xs: "50%" }}
        borderRight="1px"
        borderColor="gray.400"
      />
      <Box minW={{ base: "element.lg", sm: "element.xl" }} />
      {/* Only shown on mobile for recurring seating events */}
      {seatingObject.parent_event && (
        <Button
          data-testid="map-banner-open-timeslot-modal"
          display={{ base: "block", md: "none" }}
          paddingInlineStart="0px !important"
          paddingInlineEnd="0px !important"
          minWidth="fit-content"
          variant="link"
          onClick={onOpenTimeslotModal}
          aria-label={t("Recurring Event Info")}
          fontSize="sm"
          mr="lg"
        >
          <Icon.Category boxSize="element.xl" color="font.dark" />
        </Button>
      )}
      <Button
        data-testid="map-banner-more-info"
        paddingInlineStart="0px !important"
        paddingInlineEnd="0px !important"
        minWidth="fit-content"
        variant="link"
        onClick={onOpenInfoModal}
        aria-label={t("More Info")}
        fontSize="sm"
      >
        <Text
          fontSize="sm"
          display={{ base: "none", md: "flex" }}
          fontWeight="bold"
          color="font.dark"
          textDecoration="underline"
        >
          {t("More Info")}
        </Text>
        <Text display={{ base: "flex", md: "none" }}>
          <Icon.Info boxSize="element.xl" color="font.dark" />
        </Text>
      </Button>
    </Flex>
  );
};

export default MoreInfoButton;
